import { ApiMethod } from 'services/api';
import { useRestMutation } from 'utils/hooks/api/useRestMutation';

export const SCHEDULE_CAMPAIGN_URL = '/email/scheduleCampaignNowOrInFuture';

export const useScheduleCampaignMutation = () => {
  const { isLoading, mutate, error } = useRestMutation(SCHEDULE_CAMPAIGN_URL, ApiMethod.post);
  return { isLoading, mutate, error };
};
